import { Card, Divider, Grid, Input, MenuItem, Select, Typography } from '@mui/material';
import * as React from 'react';
import  { TextField } from '@mui/material';
import { BlackButton, OutlinedBlackButton } from '../../Styles/Button';
import { ClassicModal } from '../../Styles/Modal';
import { Link } from 'react-router-dom';
import api from '../../Api/api';



export const ModalCreation = props => {

    const { isOpen, setIsOpen } = props;
    const { produit } = props;
    const token = sessionStorage.getItem('token');

    const [image, setImage] = React.useState(); //WIP

    const initialState = {
        _id: produit?._id || '',
        title: produit?.title || '',
        subtitle: produit?.subtitle || '',
        description: produit?.description || '',
        price: produit?.price || null,
        totalUnits: produit?.totalUnits || null,
        date: produit?.date || '',
        place: produit?.place || '',
        buyers: produit?.buyers || []
    };
    
    const [{ title, subtitle, description, price, totalUnits, date, place }, setState] = React.useState(initialState);
    const [type, setType] = React.useState(produit?.type || 'atelier')

    const handleChange = itemKey => event => {
        let result = event.target.value
        setState(prevState => {
            const states = { ...prevState };
            states[itemKey] = result;
            return states;
        });
    };

    //WIP
    /* const handleImage = (event) => {
        setImage(event.target.files[0])
        console.log('handleImage called')
        console.log(event.target.files[0])
    } */

    const [isError, setIsError] = React.useState(false)
    const handleClick = async() => {
        if (textError(title) || textError(subtitle) || textError(description) || numberError(price) || numberError(totalUnits) 
            || (type==='atelier' && (dateError(date) || textError(place)))
        ) {
            setIsError(true)
        }
        else {
            setIsError(false)
            const newProduit = {
                title,
                subtitle,
                description,
                price,
                totalUnits,
                type
            }
            if (type==='atelier') {
                newProduit.date = date;
                newProduit.place = place;
            }
            /* } else {
                console.log('ici')
                newProduit.image = await api.postImage(image).path;
                console.log('newProduit.image : ', newProduit)
            } */
            handleModalValidation(newProduit)
            setIsOpen(false)
        }
    };

    const textError = (text) => {
        if (text) {
            return false
        }
        return true
    };
    const dateError = (date) => { return (!(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/).test(date) && date !== "") };
    const numberError = (number) => { return (!/^\d+(.\d{2})?$/.test(number)) };
    

    const handleModalValidation = async (newProduit) => {
        let result
        if (!produit) {
            result = await api.createProduit(newProduit, token)
        } else {
            result = await api.updateProduit(produit?._id, newProduit, token)
        }
        return result;
    }
    
    return(
        <div>
        <ClassicModal sx={{
            minWidth: "60%",
            height: "fit-content",
            margin: "auto",
            overflowY: "scroll",
            overflowX: "hidden",
            alignContent: "center"
            }}
            display="flex"
            open={isOpen}
            onClose={(e, reason) => (reason && reason === "backdropClick") ? setIsOpen(!isOpen) : null}>
                <Card id="modal" display="flex">
                    <Grid
                        display="flex"
                        container
                        padding={5}
                        rowSpacing={3}
                        columnSpacing={1}
                        direction="row"
                        margin="center"
                        justifyItems="center"
                        textAlign="center"
                    >   
                        <Grid item xs="12">
                            <Typography sx = {{
                                textAlign: "left",
                                fontSize: "30px",
                                fontWeight: "bold"
                            }}>
                                {produit
                                ? "Modifier le produit choisi"
                                : "Ajouter un produit au site"
                                }
                            </Typography>
                            <Divider sx={{paddingTop: 1, borderBottomWidth: 2}} variant="fullWidth" orientation="horizontal" flexItem/>
                        </Grid>
                        <Grid item xs="8" paddingBottom={1}>
                            <Typography sx = {{
                                textAlign: "left",
                                fontSize: "20px",
                            }}>Rentrer les informations :
                            </Typography>
                        </Grid>
                        {!produit?._id && 
                        <Grid item xs="4">
                            <Select
                                id="type-select"
                                variant="outlined"
                                value={type}
                                label="Type"
                                size="small"
                                onChange={(event) => setType(event.target.value)}
                            >
                                <MenuItem value={'atelier'}>Atelier</MenuItem>
                                <MenuItem value={'boutique'}>Boutique</MenuItem>
                            </Select>
                        </Grid>}
                        <Grid item xs="6">
                            <TextField
                                size="small"
                                id="title-textField"
                                label="Titre"
                                variant="outlined"
                                required
                                error={textError(title) && isError}
                                value={title}
                                onChange={value => handleChange('title')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size="small"
                                id="subtitle-textField"
                                label="Sous-titre"
                                variant="outlined"
                                required
                                error={textError(subtitle) && isError}
                                value={subtitle}
                                onChange={value => handleChange('subtitle')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size="small"
                                id="totalUnits-textField"
                                label="Nombre disponible"
                                helperText="Rentrer un nombre"
                                variant="outlined"
                                required
                                error={numberError(totalUnits) && isError}
                                value={totalUnits}
                                onChange={value => handleChange('totalUnits')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size="small"
                                id="price-textField"
                                label="Prix unitaire"
                                helperText="Rentrer un nombre"
                                variant="outlined"
                                required
                                error={numberError(price) && isError}
                                value={price}
                                onChange={value => handleChange('price')(value)}
                            />
                        </Grid>
                        {(type === 'atelier') ?
                        <>
                        <Grid item xs="6">
                            <TextField
                                size="small"
                                id="date-textField"
                                label="Date et Heure"
                                helperText="JJ/MM/AAAA HH:MM"
                                variant="outlined"
                                error={dateError(date) && isError}
                                value={date}
                                onChange={value => handleChange('date')(value)}
                            />
                        </Grid>
                        <Grid item xs="6">
                            <TextField
                                size="small"
                                id="place-textField"
                                label="Lieu"
                                helperText="Rentrer une adresse"
                                variant="outlined"
                                required
                                error={textError(place) && isError}
                                value={place}
                                onChange={value => handleChange('place')(value)} 
                            />
                        </Grid>
                        </>
                        :
                        <></>
                        }
                    {/* <Grid item xs="12">
                        <label>Choisir une image (PNG, JPG, JPEG) pour le produit : </label>
                        <br/>
                        <input id='file' type='file' accept="image/*" onChange={handleImage} />
                    </Grid> */}
                        <Grid item xs="12">
                        <Grid
                            container 
                            sx={{direction: 'column-reverse', alignItems: 'flex-start'}}>
                            <Grid item xs="8">
                                <TextField
                                    fullWidth
                                    id="description-textField"
                                    label="Description"
                                    variant="outlined"
                                    required
                                    multiline
                                    error={textError(description) && isError}
                                    value={description}
                                    onChange={value => handleChange('description')(value)}
                                />
                            </Grid>
                            <Grid item xs="4">
                                <BlackButton
                                    sx={{margin: 0}}
                                    variant='standard'
                                    onClick={handleClick}
                                >
                                    {produit ? "Modifier" : "Créer"}
                                </BlackButton>
                            </Grid>
                        </Grid>
                        </Grid>
                    </Grid>
                </Card>
        </ClassicModal>
        </div>
    )
}

export default ModalCreation